/* eslint-disable import/prefer-default-export */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { GetIdentityNowSourcesCacheResp } from '@src/endpoints/custom.endpoints'
import type { CorrelatedSource } from '@src/endpoints/openapis/saas-cam-correlated-sources'
import React from 'react'

export interface SourcesCache {
  state?: InitialState
  dispatch?: React.Dispatch<any>
  fetchCorrelatedSources: () => void
}

export const initialState = {
  correlatedSources: { list: [] as CorrelatedSource[], pending: false },
  identityNowSources: {
    list: [] as GetIdentityNowSourcesCacheResp,
    pending: false
  }
}

export type InitialState = typeof initialState

export const SourcesCacheContext = React.createContext<SourcesCache>({
  fetchCorrelatedSources: () => {}
})

export const SourcesCacheConsumer = SourcesCacheContext.Consumer

export const useSourcesCacheContext = () =>
  React.useContext(SourcesCacheContext)

//reducer

const SourcesCacheSlice = createSlice({
  name: 'SOURCES_CACHE_CONTEXT',
  initialState,
  reducers: {
    loadIdentityNowSources: (
      state,
      action: PayloadAction<InitialState['identityNowSources']>
    ) => {
      state.identityNowSources.list = action?.payload?.list
      state.identityNowSources.pending = action?.payload?.pending
    },
    loadCorrelatedSources: (
      state,
      action: PayloadAction<InitialState['correlatedSources']>
    ) => {
      state.correlatedSources.list = action?.payload?.list
      state.correlatedSources.pending = action?.payload?.pending
    }
  }
})

export const { reducer, actions, caseReducers } = SourcesCacheSlice
